/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React from 'react';

import Link from '@swf/components/Link/Link';
import type { ClassNameProp } from '@swf/core/types/Props';
import type { Link as LinkProps1 } from '@swf/generated/cms/types/GlobalFields';

import styles from './CMSLink.scss';

const CMSLink: React.FC<LinkProps1 & Partial<ClassNameProp>> = ({
  title,
  url,
  children,
  rel,
  target,
  className,
  track_id,
  ...rest
}) => (
  <Link
    {...rest}
    className={classNames(className, styles.link)}
    href={url}
    rel={url ? rel || undefined : undefined}
    target={url ? target ?? undefined : undefined}
    trackText={track_id}
  >
    {children || title}
  </Link>
);
export default CMSLink;
